import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SignInPage from './pages/sign_in';
import {BrowserRouter as Router, Redirect, Route} from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import MyStories from "./pages/my_stories";
import {Routes} from "./components/constants";
import ProtectedRoute from "./components/protected_route";
import AccountCreated from "./pages/sign_in/account_created_page";
import StoryEditor from "./pages/story_editor";
import {DndProvider} from 'react-dnd'
import Html5Backend from 'react-dnd-html5-backend';
import firebase from 'components/firebase'
import SharedStories from "pages/shared_stories";
import * as Sentry from '@sentry/browser';
import StoryEditorTitle from "pages/story_editor/story_editor_title";
import StoryEditorLayout from "pages/story_editor/story_editor_layout";

Sentry.init({dsn: "https://70b03915a99b411ba38542def6a08231@sentry.io/5175938"});

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authenticated: null,
        }
    }

    componentDidMount() {
        firebase.auth().onAuthStateChanged((authenticated) => {
            authenticated
                ? this.setState(() => ({
                    authenticated: true,
                }))
                : this.setState(() => ({
                    authenticated: false,
                }));
        });
    }

    render() {
        let redirectFromLogin = this.state.authenticated && (window.location.href.endsWith(Routes.signin) || window.location.href.endsWith(Routes.signup));
        if (redirectFromLogin) {
            redirectFromLogin &= firebase.auth().currentUser.emailVerified;
        }
        return (
            <DndProvider backend={Html5Backend}>
                <Router>
                    <Route exact path={Routes.signin} render={({history}) => redirectFromLogin ?
                        <Redirect push={false} to={Routes.myStories}/> : <SignInPage history={history}/>}/>
                    <Route exact path={Routes.resetPassword} render={({history}) => redirectFromLogin ?
                        <Redirect push={false} to={Routes.myStories}/> :
                        <SignInPage resetPassword history={history}/>}/>
                    <Route exact path={Routes.signup} render={({history}) => redirectFromLogin ?
                        <Redirect push={false} to={Routes.myStories}/> :
                        <SignInPage createAccount history={history}/>}/>
                    <Route exact path={Routes.accountCreated} render={({history}) => redirectFromLogin ?
                        <Redirect push={false} to={Routes.myStories}/> : <AccountCreated history={history}/>}/>
                    <ProtectedRoute exact path={Routes.myStories} component={MyStories}
                                    authenticated={this.state.authenticated}/>
                    <ProtectedRoute exact path={Routes.storyEditor} component={StoryEditor}
                                    authenticated={this.state.authenticated}/>
                    <ProtectedRoute exact path={Routes.storyEditorTitle} component={StoryEditorTitle}
                                    authenticated={this.state.authenticated}/>
                    <ProtectedRoute exact path={Routes.storyEditorLayout} component={StoryEditorLayout}
                                    authenticated={this.state.authenticated}/>
                    <ProtectedRoute exact path={Routes.storyViewer} component={StoryEditor}
                                    authenticated={this.state.authenticated}/>
                    <ProtectedRoute exact path={Routes.sharedStories} component={SharedStories}
                                    authenticated={this.state.authenticated}/>
                </Router>
            </DndProvider>
        );
    }
}

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
